import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
export const fetchUpgradeConfig = upgradeKey => {
  return http.get(`${getFullUrl('app-api')}/upgrade-management-service/v1/upgrade-configs/${upgradeKey}`).catch(error => {
    if (error && error.status !== 0) {
      Raven.captureException(error);
    }

    throw error;
  });
};